// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TaskTracker.css */
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1200px; /* 最大宽度 */
    margin: 0 auto; /* 居中 */
    padding: 20px;
}

.card {
    width: 100%;
    margin-bottom: 20px;
}

.table-responsive {
    width: 100%;
}

.task-column {
    vertical-align: middle;
    width: 32%;
    word-break: break-word;
    padding: 8px;
}

.category-column {
    width: 18%;
    vertical-align: middle;
    padding: 8px;
}

.time-column {
    width: 10%;
    vertical-align: middle;
    text-align: center;
    padding: 8px;
}

.duration-column {
    width: 10%;
    text-align: center;
    vertical-align: middle;
    padding: 8px;
}

.weight-column {
    width: 10%;
    text-align: center;
    vertical-align: middle;
    padding: 8px;
}

.score-column {
    width: 10%;
    text-align: center;
    vertical-align: middle;
    padding: 8px;
}

.actions-column {
    width: 10%;
    text-align: center;
    vertical-align: middle;
    padding: 8px;
}

.table {
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-collapse: collapse;
}

.table th, .table td {
    padding: 8px;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

.table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
}

.table tbody + tbody {
    border-top: 2px solid #dee2e6;
}

.table-hover tbody tr:hover {
    color: #212529;
    background-color: rgba(0,0,0,.075);
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0,0,0,.05);
}

.timer {
    font-size: 24px;
    font-weight: bold;
    margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/TaskTracker.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,iBAAiB,EAAE,SAAS;IAC5B,cAAc,EAAE,OAAO;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":["/* TaskTracker.css */\r\n.container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 100%;\r\n    max-width: 1200px; /* 最大宽度 */\r\n    margin: 0 auto; /* 居中 */\r\n    padding: 20px;\r\n}\r\n\r\n.card {\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.table-responsive {\r\n    width: 100%;\r\n}\r\n\r\n.task-column {\r\n    vertical-align: middle;\r\n    width: 32%;\r\n    word-break: break-word;\r\n    padding: 8px;\r\n}\r\n\r\n.category-column {\r\n    width: 18%;\r\n    vertical-align: middle;\r\n    padding: 8px;\r\n}\r\n\r\n.time-column {\r\n    width: 10%;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    padding: 8px;\r\n}\r\n\r\n.duration-column {\r\n    width: 10%;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    padding: 8px;\r\n}\r\n\r\n.weight-column {\r\n    width: 10%;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    padding: 8px;\r\n}\r\n\r\n.score-column {\r\n    width: 10%;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    padding: 8px;\r\n}\r\n\r\n.actions-column {\r\n    width: 10%;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    padding: 8px;\r\n}\r\n\r\n.table {\r\n    width: 100%;\r\n    margin-bottom: 1rem;\r\n    color: #212529;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.table th, .table td {\r\n    padding: 8px;\r\n    vertical-align: top;\r\n    border-top: 1px solid #dee2e6;\r\n}\r\n\r\n.table thead th {\r\n    vertical-align: bottom;\r\n    border-bottom: 2px solid #dee2e6;\r\n}\r\n\r\n.table tbody + tbody {\r\n    border-top: 2px solid #dee2e6;\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n    color: #212529;\r\n    background-color: rgba(0,0,0,.075);\r\n}\r\n\r\n.table-striped tbody tr:nth-of-type(odd) {\r\n    background-color: rgba(0,0,0,.05);\r\n}\r\n\r\n.timer {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    margin-left: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
